import { vaultPostRequest } from '../helpers';
import type { IRetryFailedUploadsResponse } from './retry-failed-uploads-response';
import { retryFailedUploadsResponseSchema } from './retry-failed-uploads-response';

export async function retryFailedUploadsApi(): Promise<IRetryFailedUploadsResponse> {
  return vaultPostRequest({
    path: '/upload/queue/retry-failed',
    body: {},
    schema: retryFailedUploadsResponseSchema,
  });
}
